// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Redirect from deprecated singular route to plural route with params.
 */
export const Route = createFileRoute('/_app/fulfillment/$fulfillmentKey')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/fulfillments/$fulfillmentKey',
      params: { fulfillmentKey: params.fulfillmentKey },
    });
  },
});
